import { render, staticRenderFns } from "./PList.vue?vue&type=template&id=63379aed&scoped=true"
import script from "./PList.vue?vue&type=script&lang=js"
export * from "./PList.vue?vue&type=script&lang=js"
import style0 from "./PList.vue?vue&type=style&index=0&id=63379aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63379aed",
  null
  
)

export default component.exports